import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const NavWrapper = styled.div<any>`
  position: relative;
  background-color: ${(props) => props.theme.colors?.white};
`;

const StyledSection = styled.section<{ isReadOnlyUrl?: boolean }>`
  display: ${(props) => (props.isReadOnlyUrl ? 'grid' : 'flex')};
  background-color: ${(props) => props.theme.colors?.white};
  ${(props) =>
    props.isReadOnlyUrl
      ? `
    grid-template-columns: 1fr 3fr;
  `
      : `
    justify-content: space-between;
  `}
  @media (min-width: 1024px) and (max-width: 1440px) {
    width: 94%;
  }
`;

const NavItem = styled.span<{ selected?: boolean }>`
  cursor: pointer;
  margin: 0 0.75rem 0 1rem;
  padding: 10px 20px;
  display: list-item;
  white-space: nowrap;
  border-bottom: ${(props) =>
    props.selected ? `2px solid ${props.theme.colors?.blue[600]}` : 'none'};
  @media (max-width: 1560px) {
    margin: 0 0.375rem 0 0.5rem;
    padding: 6px 10px;
    font-size: 0.875rem;
  }
`;

const NavLink = styled(Link)`
  color: ${(props) => props.theme.colors?.black};
`;

export { StyledSection, NavItem, NavWrapper, NavLink };
